import React from 'react';
import App from 'next/app';

import printJoinUsMessage from '@nubank/www-latam-commons/utils/asciiart/printJoinUsMessage';
import { compose } from '@nubank/www-latam-commons/utils/functionalUtils';
import { persistMGMParameters } from '@nubank/www-latam-commons/utils/mgmUtils';
import { queryStringToParameters } from '@nubank/www-latam-commons/utils/urlUtils';
import addWebpSupportClass from '@nubank/www-latam-commons/utils/browserFeatures/webp/addWebpSupportClass';
import ImgGlobalStyle from '@nubank/www-latam-commons/styles/ImgGlobalStyles';
import { persistMarketingURL } from '@nubank/www-latam-commons/utils/marketingUtils';

import { SiteContextProvider } from '../components/SiteContext/SiteContext';
import '@splidejs/react-splide/dist/css/splide-core.min.css';
import { RecaptchaGlobalStyle } from '../utils/recaptcha';
import { errorTracking } from '../utils/error-tracking/errorTracking';

errorTracking.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NODE_ENV,
});

export default class CustomApp extends App {
  constructor(props, ctx) {
    super(props, ctx);
    printJoinUsMessage('https://boards.greenhouse.io/nubank?gh_src=beda5e891');
  }

  // Note: This getInitialProps is needed for pages that accept query parameters
  // It doesn't interfere with getStaticProps since it just returns empty props
  static async getInitialProps() {
    return {};
  }

  async componentDidMount() {
    persistMarketingURL(document.location);

    compose(
      persistMGMParameters(),
      queryStringToParameters,
    )(document.location.search);

    addWebpSupportClass(document.querySelector('body'));
  }

  render() {
    const { Component, pageProps } = this.props;

    return (
      <>
        <ImgGlobalStyle />
        <RecaptchaGlobalStyle />
        <SiteContextProvider>
          <Component {...pageProps} />
        </SiteContextProvider>
      </>
    );
  }
}
